window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('providiobase/main'));
    processInclude(require('./components/customSiteOverride'));

    $(document).on('click', '.collection-product-grid .add-to-cart', function () {
        var pid;
        var addToCartUrl;
        var pidsQty = 1;

        $('body').trigger('product:beforeAddToCart', this);

        pid = $(this).data('pid');
        addToCartUrl = window.resources.urls.AddToCart;
        var form = {
            pid: pid,
            quantity: pidsQty
        };

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    if (data && !data.error) {
                        $('.minicart').trigger('count:update', data);
                        $('body').trigger('product:afterAddToCart', data);
                    }
                    $.spinner().stop();

                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
});

window.addBlogData = function(data) {
    if (window.resources.urls.BlogListURL) {
        var form = {
            blogData: data ? JSON.stringify(data) : JSON.stringify({})
        };
        $.ajax({
            url: window.resources.urls.BlogListURL,
            method: 'POST',
            data: form,
            success: function (response) {
                if (response) {
                    $('.blogs-list').html(response);
                    $('.blog-results').removeClass('d-none');
                }

            },
            error: function () {
                $('.blog-results').removeClass('d-none').addClass('d-none');
            }
        });
    }
}